(function () {
	const initProductAccordion = () => {
		const accordionToggles = document.querySelectorAll('.about__accordion-toggle[data-accordion-toggle]');
		
		accordionToggles.forEach((toggle) => {
			// Remove existing listeners to avoid duplicates
			const newToggle = toggle.cloneNode(true);
			toggle.parentNode.replaceChild(newToggle, toggle);
			
			newToggle.addEventListener('click', function(e) {
				e.preventDefault();
				const accordionItem = this.closest('.about__accordion-item');
				const content = accordionItem.querySelector('[data-accordion-content]');
				const isActive = this.classList.contains('active');
				
				if (!isActive) {
					// Open
					this.classList.add('active');
					this.setAttribute('aria-expanded', 'true');
					if (content) {
						content.style.display = 'block';
						// Smooth animation
						const height = content.scrollHeight;
						content.style.height = '0px';
						content.style.overflow = 'hidden';
						content.style.transition = 'height 300ms ease';
						
						setTimeout(() => {
							content.style.height = height + 'px';
						}, 10);
						
						setTimeout(() => {
							content.style.height = 'auto';
							content.style.overflow = '';
						}, 310);
					}
				} else {
					// Close
					this.classList.remove('active');
					this.setAttribute('aria-expanded', 'false');
					if (content) {
						const height = content.scrollHeight;
						content.style.height = height + 'px';
						content.style.overflow = 'hidden';
						content.style.transition = 'height 300ms ease';
						
						setTimeout(() => {
							content.style.height = '0px';
						}, 10);
						
						setTimeout(() => {
							content.style.display = 'none';
							content.style.height = '';
							content.style.overflow = '';
							content.style.transition = '';
						}, 310);
					}
				}
			});
		});
	};

	// Initialize on page load
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initProductAccordion);
	} else {
		initProductAccordion();
	}

	// Re-initialize when Shopify theme editor loads sections
	document.addEventListener("shopify:section:load", function () {
		initProductAccordion();
	});
	
	// Re-initialize when Shopify theme editor selects sections
	document.addEventListener("shopify:section:select", function () {
		initProductAccordion();
	});
})();
